let isDev = false;

let config = {
    dev: {
        apiDomain: "https://apidev.e-ot.io",
        aiDomain: 'https://mandrifit-prod.e-ot.io',
        // apiDomain: "https://apibeta.e-ot.io",
        purchaseDomain : "https://purchase-dev.e-ot.io",
        elasticOption: {
            index: 'eot_item_dev',
            type: '_doc',
        },
    },
    prod: {

        apiDomain: "https://api.e-ot.io",
        aiDomain: 'https://mandrifit-prod.e-ot.io',
        purchaseDomain : "https://purchase-dev.e-ot.io",

        elasticOption: {
            index: 'eot_item_prod',
            type: '_doc',
        },
    }
}

function getConfig(key='apiDomain') {
    return isDev ? config.dev[key] : config.prod[key];
}

function setConfig(key, value) {
    if (isDev) {
        config.dev[key] = value;
    } else {
        config.prod[key] = value;
    }
}


let apiDomain = getConfig('apiDomain')
let apiURL = `${getConfig('apiDomain')}/api/`;
let elasticOption = getConfig('elasticOption');
let aiDomain = getConfig('aiDomain');
let aiApiURL = `${getConfig('aiDomain')}/api/`;
let purchaseDomain = getConfig('purchaseDomain');
let purchaseURL = `${getConfig('purchaseDomain')}/api/`;


export {apiURL, apiDomain, isDev,elasticOption, setConfig, aiDomain, aiApiURL, purchaseDomain, purchaseURL};
//import {elasticOption} from "@/api/config";
